const imgData_merchandinse = {
  birds_of_ireland_2021_stickers: {
    title: '"Birds of Ireland" sticker sheet',
    imgs: {
      full: {
        src: require('./birds_of_ireland_2021_web.jpg'),
        width: 1125,
        height: 1500,
      },
      thumb: {
        src: require('./birds_of_ireland_2021_thumb.jpg'),
        width: 450,
        height: 600,
      },
    },
    year: '2022',
    description: 'A set of 6 vinyl Irish bird stickers. ',
    /* prettier-ignore */
    price: 5.50,
    buyUrl: 'https://www.etsy.com/ie/listing/1104312816/',
    discount: 0,
    type: 'merchandise',
    subType: 'stickers',
  },
  affection_greeting_card: {
    title: '"Affection" Stag and Doe Greeting Card',
    imgs: {
      full: {
        src: require('./affection_greeting_card_web.jpg'),
        width: 1125,
        height: 1500,
      },
      thumb: {
        src: require('./affection_greeting_card_thumb.jpg'),
        width: 450,
        height: 600,
      },
    },
    year: '2022',
    description: 'Greeting card with the artwork "Affection" printed on it.',
    /* prettier-ignore */
    price: 4.90,
    buyUrl: 'https://www.etsy.com/ie/listing/1159323797/',
    discount: 0,
    type: 'merchandise',
    subType: 'greeting_cards',
  },
  winter_birds_greeting_cards: {
    title: 'Winter Birds Christmas Cards',
    imgs: {
      full: {
        src: require('./winter_birds_2021_2021_web.jpg'),
        width: 1000,
        height: 1333,
      },
      thumb: {
        src: require('./winter_birds_2021_2021_thumb.jpg'),
        width: 600,
        height: 800,
      },
    },
    year: '2021',
    description: 'Christmas greeting cards with 4 different garden songbirds.',
    /* prettier-ignore */
    price: 3.50,
    buyUrl: 'https://www.etsy.com/ie/listing/1114482253/',
    discount: 0,
    type: 'merchandise',
    subType: 'greeting_cards',
  },
  ivy_gentleman_tshirt: {
    title: "Ivy Gentleman Women's short sleeved tee",
    imgs: {
      full: {
        src: require('./ivy_gentleman_tshirt_2021_web.jpg'),
        width: 1000,
        height: 1001,
      },
      thumb: {
        src: require('./ivy_gentleman_tshirt_2021_thumb.jpg'),
        width: 600,
        height: 601,
      },
    },
    year: '2021',
    description:
      "Women's 100% cotton short sleeved t-shirt with blackbird print.",
    /* prettier-ignore */
    price: 30.50,
    buyUrl: 'https://www.etsy.com/ie/listing/1007951583/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  bone_raven_womens_tee: {
    title: "Bone Raven Women's short sleeved tee",
    imgs: {
      full: {
        src: require('./bone_raven_tshirt_2021_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./bone_raven_tshirt_2021_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2021',
    description: "Women's 100% cotton short sleeved t-shirt with crow print.",
    /* prettier-ignore */
    price: 32.50,
    buyUrl: 'https://www.etsy.com/ie/listing/995282674/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  dragon_dance_1_bookmark_set: {
    title: 'Dragon Dance bookmark set',
    imgs: {
      full: {
        src: require('./dragon_dance_1_bookmark_set_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./dragon_dance_1_bookmark_set_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description:
      'A set of 3 handmade paper bookmarks with dragon prints, feather charms and tassels.',
    /* prettier-ignore */
    price: 4.50,
    buyUrl: 'https://www.etsy.com/ie/listing/904511925/',
    discount: 0,
    type: 'merchandise',
    subType: 'bookmark_set',
  },
  swans_of_ireland_bookmark_set: {
    title: 'Swans of Ireland bookmark set',
    imgs: {
      full: {
        src: require('./swans_of_ireland_2021_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./swans_of_ireland_2021_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2021',
    description:
      'A set of 3 handmade paper bookmarks with rose charm and tassel.',
    /* prettier-ignore */
    price: 4.50,
    buyUrl: 'https://www.etsy.com/ie/listing/964814293/',
    discount: 0,
    type: 'merchandise',
    subType: 'bookmark_set',
  },
  low_tide_tale_greeting_card: {
    title: 'Low Tide Tale greeting card',
    imgs: {
      full: {
        src: require('./low_tide_tale_2021_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./low_tide_tale_2021_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2021',
    description: 'Greeting card with egret print in a white envelope.',
    /* prettier-ignore */
    price: 3.50,
    buyUrl: 'https://www.etsy.com/ie/listing/953617477/',
    discount: 0,
    type: 'merchandise',
    subType: 'greeting_cards',
  },
  buttercups_unisex_tshirt: {
    title: 'Buttercups unisex tee',
    imgs: {
      full: {
        src: require('./buttercups_tshirt_2021_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./buttercups_tshirt_2021_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2021',
    description: '100% cotton unisex t-shirt with a robin print.',
    /* prettier-ignore */
    price: 32,
    buyUrl: 'https://www.etsy.com/ie/listing/941546699/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  birds_in_love_greeting_cards: {
    title: 'Birds in Love greeting cards',
    imgs: {
      full: {
        src: require('./birds_in_love_greeting_cards_2021_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./birds_in_love_greeting_cards_2021_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2021',
    description:
      'Greeting cards with 3 different bird pair prints, in white envelopes.',
    /* prettier-ignore */
    price: 3.50,
    buyUrl: 'https://www.etsy.com/ie/listing/943508801/',
    discount: 0,
    type: 'merchandise',
    subType: 'greeting_cards',
  },
  birds_in_love_postcards: {
    title: 'Birds in Love postcard set',
    imgs: {
      full: {
        src: require('./birds_in_love_postcards_2021_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./birds_in_love_postcards_2021_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2021',
    description: 'Postcard set with 3 different bird pair prints.',
    /* prettier-ignore */
    price: 5.00,
    buyUrl: 'https://www.etsy.com/ie/listing/928314268/',
    discount: 0,
    type: 'merchandise',
    subType: 'greeting_cards',
  },
  sandworts_unisex_tshirt: {
    title: 'Sandworts unisex tee',
    imgs: {
      full: {
        src: require('./sandworts_tshirt_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./sandworts_tshirt_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description: 'Unised t-shirt with blue tit print.',
    /* prettier-ignore */
    price: 32.50,
    buyUrl: 'https://www.etsy.com/ie/listing/941546297/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  cuckooflowers_unisex_tshirt: {
    title: 'Cuckooflowers unisex tee',
    imgs: {
      full: {
        src: require('./cuckooflowers_tshirt_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./cuckooflowers_tshirt_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description: 'Unised t-shirt with heron print.',
    /* prettier-ignore */
    price: 34.50,
    buyUrl: 'https://www.etsy.com/ie/listing/941545811/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  alfalfa_womens_tshirt: {
    title: "Alfalfa women's short sleeved t-shirt",
    imgs: {
      full: {
        src: require('./alfalfa_tshirt_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./alfalfa_tshirt_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description:
      "Women's short sleeved t-shirt with a blue merle border collie print.",
    /* prettier-ignore */
    price: 32.00,
    buyUrl: 'https://www.etsy.com/ie/listing/906857911/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  alfalfa_mens_tshirt: {
    title: "Alfalfa women's short sleeved t-shirt",
    imgs: {
      full: {
        src: require('./alfalfa_mens_tshirt_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./alfalfa_mens_tshirt_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description:
      "Women's short sleeved t-shirt with a blue merle border collie print.",
    /* prettier-ignore */
    price: 32.00,
    buyUrl: 'https://www.etsy.com/ie/listing/906857911/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  christmas_tits_2020_greeting_cards: {
    title: 'Christmas Tits 2020 greeting card set',
    imgs: {
      full: {
        src: require('./christmas_tits_greeting_cards_2020_web.jpg'),
        width: 1000,
        height: 1393,
      },
      thumb: {
        src: require('./christmas_tits_greeting_cards_2020_thumb.jpg'),
        width: 600,
        height: 836,
      },
    },
    year: '2020',
    description:
      'A set of 3 blue and coal tit Christmas greeting cards with white envelopes.',
    /* prettier-ignore */
    price: 8.00,
    buyUrl: 'https://www.etsy.com/ie/listing/1113158071/',
    discount: 0,
    type: 'merchandise',
    subType: 'greeting_cards',
  },
  christmas_robins_2020_greeting_cards: {
    title: 'Christmas Robins 2020 greeting card set',
    imgs: {
      full: {
        src: require('./christmas_robins_greeting_cards_2020_web.jpg'),
        width: 1000,
        height: 1333,
      },
      thumb: {
        src: require('./christmas_robins_greeting_cards_2020_thumb.jpg'),
        width: 600,
        height: 800,
      },
    },
    year: '2020',
    description:
      'A set of 3 robin Christmas greeting cards with white envelopes.',
    /* prettier-ignore */
    price: 8.00,
    buyUrl: 'https://www.etsy.com/ie/listing/1112573263/',
    discount: 0,
    type: 'merchandise',
    subType: 'greeting_cards',
  },
  rascals_artist_sketchbook: {
    title: "Rascals artist's sketchbook",
    imgs: {
      full: {
        src: require('./rascals_notebook_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./rascals_notebook_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description:
      'A spiral sketchbook with rustic, thick pages and a starling print.',
    /* prettier-ignore */
    price: 23.00,
    buyUrl: 'https://www.etsy.com/ie/listing/888840913/',
    discount: 0,
    type: 'merchandise',
    subType: 'notebooks',
  },
  rascals_womens_tshirt: {
    title: "Rascals women's tee",
    imgs: {
      full: {
        src: require('./rascals_womens_tshirt_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./rascals_womens_tshirt_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description: "Women's short sleeved t-shirt with starling print.",
    /* prettier-ignore */
    price: 32.00,
    buyUrl: 'https://www.etsy.com/ie/listing/1021281161/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  rascals_mens_tshirt: {
    title: "Rascals men's tee",
    imgs: {
      full: {
        src: require('./rascals_mens_tshirt_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./rascals_mens_tshirt_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description: "Men's short sleeved t-shirt with starling print.",
    /* prettier-ignore */
    price: 31.50,
    buyUrl: 'https://www.etsy.com/ie/listing/875381994/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  farewell_womens_tshirt: {
    title: "Farewell women's tee",
    imgs: {
      full: {
        src: require('./farewell_womens_tshirt_2020_web.jpg'),
        width: 1000,
        height: 2000,
      },
      thumb: {
        src: require('./farewell_womens_tshirt_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description: "Women's short sleeved t-shirt with swallow print.",
    /* prettier-ignore */
    price: 28.00,
    buyUrl: 'https://www.etsy.com/ie/listing/864817848/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  farewell_mens_tshirt: {
    title: "Farewell men's tee",
    imgs: {
      full: {
        src: require('./farewell_mens_tshirt_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./farewell_mens_tshirt_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description: "Men's short sleeved t-shirt with swallow print.",
    /* prettier-ignore */
    price: 28.50,
    buyUrl: 'https://www.etsy.com/ie/listing/875079870/',
    discount: 0,
    type: 'merchandise',
    subType: 'clothing',
  },
  farewell_hardcover_notebook: {
    title: 'Farewell hardcover notebook',
    imgs: {
      full: {
        src: require('./farewell_notebook_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./farewell_notebook_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description:
      'A hardcover notebook with swallow print, blank pages and coloured elastic band.',
    /* prettier-ignore */
    price: 14.95,
    buyUrl: 'https://www.etsy.com/ie/listing/895826951/',
    discount: 0,
    type: 'merchandise',
    subType: 'notebooks',
  },
  sparrowhawk_spiral_notebook: {
    title: 'Sparrowhawk spiral notebook',
    imgs: {
      full: {
        src: require('./sparrowhawk_notebook_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./sparrowhawk_notebook_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description: 'A spiral notebook with sparrowhawk print and blank pages.',
    /* prettier-ignore */
    price: 20.95,
    buyUrl: 'https://www.etsy.com/ie/listing/911212429/',
    discount: 0,
    type: 'merchandise',
    subType: 'notebooks',
  },
  sparrowhawk_fridge_magnet: {
    title: 'Sparrowhawk fridge magnet',
    imgs: {
      full: {
        src: require('./sparrowhawk_magnet_2020_web.jpg'),
        width: 1000,
        height: 1000,
      },
      thumb: {
        src: require('./sparrowhawk_magnet_2020_thumb.jpg'),
        width: 600,
        height: 600,
      },
    },
    year: '2020',
    description: 'Fridge magnet with the artwork "Sparrowhawk".',
    /* prettier-ignore */
    price: 5.15,
    buyUrl: 'https://www.etsy.com/ie/listing/882191122/',
    discount: 0,
    type: 'merchandise',
    subType: 'magnets',
  },
};

export default imgData_merchandinse;
